import { TeamOutlined } from '@ant-design/icons';
import { Popover, Space } from 'antd';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';

export interface ApplicantsTableCell {
  mainOwner?: string | null;
  multipleApplicants?: boolean;
  others?: string[];
  mainOwnerFiscalCode: string;
}

export interface ApplicantsTableCellProps {
  applicants?: ApplicantsTableCell;
}

/**
 * Visualizzazione dei Titolari in una cella di tabella
 */
export function ApplicantsTableCell(props: ApplicantsTableCellProps) {
  const { applicants } = props;
  const { t } = useTranslation();
  if (!applicants) return null;

  const mainOwnerInfo = isEmpty(applicants.mainOwner?.trim())
    ? applicants.mainOwnerFiscalCode
    : applicants.mainOwner;

  return (
    <Space>
      {mainOwnerInfo}
      {applicants.multipleApplicants &&
        applicants.others &&
        applicants.others?.length > 0 && (
          <Popover
            title={t('submission.altri-titolari', 'Altri titolari')}
            content={
              <ul>
                {applicants.others.map((name, index) => (
                  <li key={index}>
                    <em>{name}</em>
                  </li>
                ))}
              </ul>
            }
          >
            <TeamOutlined />
          </Popover>
        )}
    </Space>
  );
}
